import React from 'react';
import styled from '@emotion/styled';

import MainTable from './MainTable';

const Wrapper = styled('div')`
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 24px;
  margin-bottom: 150px;
  position: relative;
  .fixed-table-container {
    overflow-x: auto;
  }
  .alert-secondary {
    background: #f5f5f5;
    border-radius: 4px;
    padding: 14px;
    color: #6e768e;
  }
`;

const items = [
  {
    category: 'Приемка',
    items: [
      {
        name: 'Отпаривание товара',
        count: 'ед. товара',
        price: 300,
      },
      {
        name: 'Отпаривание товара',
        count: 'ед. товара',
        price: 300,
      },
    ],
  },
];

const MainBlock = () => {
  return (
    <Wrapper>
      <div className="alert alert-secondary mb-3">
        <i className="mdi mdi-alert-circle-outline me-2 mr-2" />B случае если тарифы приведенные на
        сайте не соответствуют тарифам в подписанном договоре, правильными являются тарифы в
        подписанном договоре. Все суммы указаны с учетом НДС.
      </div>
      <MainTable items={items} />
    </Wrapper>
  );
};

export default MainBlock;
